
import { mdiArrowAll, mdiArrowTopLeftBottomRight, mdiCheck } from "@mdi/js";
import GalleryPhoto from "@/components/ui/GalleryPhoto.vue";

export default {
  components: {
    GalleryPhoto,
  },
  props: {
    photo: {
      type: Object,
      default: () => {},
    },
    editable: {
      type: Boolean,
      default: false,
    },
    checkable: {
      type: Boolean,
      default: false,
    },
    readable: {
      type: Boolean,
      default: false,
    },
    alt: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    galleryType: {
      type: String,
      default: "",
    },
    withComplement: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["check-changed"],

  data() {
    return {
      mdiArrowAll,
      mdiArrowTopLeftBottomRight,
      mdiCheck,
    };
  },

  computed: {},

  methods: {
    statusColor(status) {
      switch (status) {
        case "approved":
          return "#1fae1f";
        case "blocked":
          return "#ff0000";
        case "wait":
          return "#ff8c00";
        default:
          return "#ff8c00";
      }
    },

    checkChanged(isChecked) {
      this.$emit("check-changed", isChecked);
    },
  },
};
